import api from './baseApi';

export const confirmSubscription = async (
    store: string,
    chargeId: string,
    timestamp: string,
    nonce: string,
    key: string
): Promise<{
    redirectUrl: string;
}> => {
    const response = await api.post(`payment/shopify/${store}/confirmed`, undefined, {
        params: {
            chargeId: chargeId,
            timestamp: timestamp,
            nonce: nonce,
            key: key
        }
    });
    return response.data;
};
